import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { logout } from '../../redux/actions/authActions';
import {
  FiHome,
  FiGrid,
  FiBox,
  FiShoppingBag,
  FiUsers,
  FiCreditCard,
  FiMapPin,
  FiLogOut,
  FiExternalLink,
  FiSliders,
  FiPaperclip
} from 'react-icons/fi';
import { logoApplication } from '../../config/dataApi';
import { ROUTES } from '../../config/routing';
import { toast } from 'sonner';

const AdminLayout = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    dispatch(logout());
    navigate('/admin/login');
  };

  // Dans ton composant principal (ex: AdminLayout)
useEffect(() => {
  const checkExpiryWarning = () => {
    const expiresAt = localStorage.getItem('expiresAt');
    if (!expiresAt) return;

    const timeLeft = parseInt(expiresAt, 10) - new Date().getTime();
    if (timeLeft < 5 * 60 * 1000) { // Moins de 5 min
      toast.warning("Votre session expire dans 5 minutes.", { duration: 10000 });
    }
  };

  const interval = setInterval(checkExpiryWarning, 30000); // Vérifie toutes les 30s
  return () => clearInterval(interval);
}, []);

  // Fonction pour vérifier si le lien est actif
  const isActive = (path) => {
    return location.pathname.startsWith(path);
  };

  return (
    <div className="d-flex vh-100 bg-light">
      {/* Sidebar */}
      <div className="bg-white text-dark d-flex flex-column" style={{ width: '250px' }}>
        <div className="p-4 border-bottom border-secondary">
          <h5 className="fw-bold mb-0"><img src={logoApplication} style={{ height:"50px", width:"50px" }}/></h5>
        </div>

        <nav className="flex-grow-1 overflow-auto p-3">
          <ul className="nav flex-column">
            <li className="nav-item">
              <Link
                to={`/${ROUTES.ADMIN_DASHBOARD}`}
                className={`nav-link px-3 py-2 rounded ${isActive(`/${ROUTES.ADMIN_DASHBOARD}`) ? 'bg-danger text-white' : 'text-dark'}`}
                style={{ width:"250px" }}
              >
                <FiHome size={18} className="me-2" /> Tableau de bord
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to={`/${ROUTES.ADMIN_CATEGORIES}`}
                className={`nav-link px-3 py-2 rounded ${isActive(`/${ROUTES.ADMIN_CATEGORIES}`) ? 'bg-danger text-white' : 'text-dark'}`}
                style={{ width:"250px" }}
              >
                <FiGrid size={18} className="me-2" /> Catégories
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to={`/${ROUTES.ADMIN_PRODUCTS}`}
                className={`nav-link px-3 py-2 rounded ${isActive(`/${ROUTES.ADMIN_PRODUCTS}`) ? 'bg-danger text-white' : 'text-dark'}`}
                style={{ width:"250px" }}
              >
                <FiBox size={18} className="me-2" /> Produits
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to={`/${ROUTES.ADMIN_ORDERS}`}
                className={`nav-link px-3 py-2 rounded ${isActive(`/${ROUTES.ADMIN_ORDERS}`) ? 'bg-danger text-white' : 'text-dark'}`}
                style={{ width:"250px" }}
              >
                <FiShoppingBag size={18} className="me-2" /> Commandes
              </Link>
            </li>

            <li className="nav-item">
              <Link
                to={`/${ROUTES.ADMIN_PUBS}`}
                className={`nav-link px-3 py-2 rounded ${isActive(`/${ROUTES.ADMIN_PUBS}`) ? 'bg-danger text-white' : 'text-dark'}`}
                style={{ width:"250px" }}
              >
                <FiPaperclip size={18} className="me-2" /> Publicités
              </Link>
            </li>

            <li className="nav-item">
              <Link
                to={`/${ROUTES.ADMIN_BANNERS}`}
                className={`nav-link px-3 py-2 rounded ${isActive(`/${ROUTES.ADMIN_BANNERS}`) ? 'bg-danger text-white' : 'text-dark'}`}
                style={{ width:"250px" }}
              >
                <FiSliders size={18} className="me-2" /> Slides
              </Link>
            </li>
            {/* <li className="nav-item">
              <Link
                to="/admin/customers"
                className={`nav-link px-3 py-2 rounded ${isActive('/admin/customers') ? 'bg-danger text-white' : 'text-dark'}`}
              >
                <FiUsers size={18} className="me-2" /> Clients
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/admin/transactions"
                className={`nav-link px-3 py-2 rounded ${isActive('/admin/transactions') ? 'bg-danger text-white' : 'text-dark'}`}
              >
                <FiCreditCard size={18} className="me-2" /> Transactions
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/admin/postal-codes"
                className={`nav-link px-3 py-2 rounded ${isActive('/admin/postal-codes') ? 'bg-danger text-white' : 'text-dark'}`}
              >
                <FiMapPin size={18} className="me-2" /> Codes Postaux
              </Link>
            </li> */}
            <li className="nav-item mt-3 pt-3 border-top border-secondary">
              <Link to="/" className="nav-link px-3 py-2 text-dark">
                <FiExternalLink size={18} className="me-2" /> Voir le site
              </Link>
            </li>
          </ul>
        </nav>

        <div className="p-3 border-top border-secondary">
          <button onClick={handleLogout} className="btn btn-outline-light w-100 d-flex align-items-center">
            <FiLogOut size={18} className="me-2" /> Déconnexion
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-grow-1 d-flex flex-column overflow-hidden">
        {/* Topbar */}
        <header className="bg-white shadow-sm sticky-top">
          <div className="container-fluid py-3 px-4 d-flex justify-content-between align-items-center">
            <h6 className="mb-0 fw-semibold">Panneau d'administration</h6>
            <div className="d-flex align-items-center">
              <span className="small text-muted me-2">Admin</span>
              <div className="rounded-circle bg-primary d-flex align-items-center justify-content-center text-dark" style={{ width: '30px', height: '30px' }}>
                A
              </div>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-grow-1 overflow-auto bg-light p-4">
          <div className="container-fluid">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;